import { AssignmentPagination, AssignmentPaginationParameters } from "@carnegie-learning/data-access-angular-passport";
import { Action, createReducer, on } from "@ngrx/store";
import { PPAssignment as Assignment } from "cli-types";
import * as fromAssignmentsStudentsActions from "../actions/assignments-students.action";

export interface AssignmentsStudentsListState {
    entities: Map<number, Assignment>;
    loaded: boolean;
    loading: boolean;
    rawResponse: AssignmentPagination | null;
    paginationParams: AssignmentPaginationParameters;
}

export const initialState: AssignmentsStudentsListState = {
    entities: new Map<number, Assignment>(),
    loaded: false,
    loading: false,
    rawResponse: null,
    paginationParams: {
        filter: { status: [] },
        limit: 25,
        page: 0,
        search: "",
        sorting: { lastName: "asc" },
    },
};
const assignmentsStudentsListReducer = createReducer(
    initialState,
    on(
        fromAssignmentsStudentsActions.loadCourseAssignmentsStudents,
        (state, { payload }) => {
            return {
                ...state,
                loading: true,
                loaded: false,
            };
        }
    ),
    on(
        fromAssignmentsStudentsActions.loadCourseAssignmentsStudentsSuccess,
        (state, { payload }) => {
            const assignments = payload.data;

            const entities = new Map<number, Assignment>();
            assignments.forEach((assignment) => {
                entities.set(assignment.assignmentID, assignment);
            });

            // then re-bind the entity const with our returned state
            return {
                ...state,
                loading: false,
                loaded: true,
                entities: entities,
                rawResponse: payload,
            };
        }
    ),
    on(
        fromAssignmentsStudentsActions.loadCourseAssignmentsStudentsFail,
        (state, { payload }) => {
            return {
                ...state,
                loading: false,
                loaded: false,
            };
        }
    ),
    on(
        fromAssignmentsStudentsActions.deleteCourseAssignmentsStudentSuccess,
        (state, { assignmentID }) => {
            const entities = new Map<number, Assignment>(
                state.entities.entries()
            );
            entities.delete(assignmentID);

            return {
                ...state,
                entities: entities,
            };
        }
    ),
    on(
        fromAssignmentsStudentsActions.setCourseAssignmentsStudentPaginationParams,
        (state, { payload }) => {
            const studentPaginationParams = {
                ...state.paginationParams,
                ...payload,
            };
            return {
                ...state,
                paginationParams: studentPaginationParams,
            };
        }
    ),
    on(
        fromAssignmentsStudentsActions.resetAssignmentOverviewPageStore,
        (state) => {
            return initialState;
        }
    )
);
export function reducer(
    state: AssignmentsStudentsListState | undefined,
    action: Action
) {
    return assignmentsStudentsListReducer(state, action);
}

// this is where we want to export some levels of state
export const getCourseAssignmentsStudentsEntities = (
    state: AssignmentsStudentsListState
) => state.entities;
export const getCourseAssignmentsStudentsLoading = (
    state: AssignmentsStudentsListState
) => state.loading;
export const getCourseAssignmentsStudentsLoaded = (
    state: AssignmentsStudentsListState
) => state.loaded;
export const getCourseAssignmentsRawResponse = (
    state: AssignmentsStudentsListState
) => state.rawResponse;
export const getCourseAssignmentsStudentsPaginationParams = (
    state: AssignmentsStudentsListState
) => state.paginationParams;
